import React, { Component } from 'react'
import Switch from '@material-ui/core/Switch';

import './DesktopRepeat.css';

export default class DesktopRepeat extends Component {
  render() {
    const { openRepeat, selectedRepeat, repeats, repeat, closeRepeat } = this.props;
    return (
      <div className="repeat d-flex flex-column">
        <div className="repeat__header d-flex">
          <h2>تکرار</h2>
          <Switch
            // checked={this.props.switchs.value}
            color="primary"
            inputProps={{ 'aria-label': 'primary checkbox' }}
            onChange={(e) => openRepeat()}
          />
        </div>
        <div className="repeat__buttons ui buttons d-flex">
          {
            repeats.map(item => (
              <div className={repeat ? "ui button" : "ui button disabled"} style={item.checked && repeat ? { border: '1px solid #506ED1', color: '#506ED1' } : { color: '#d1d1d1', border: '1px solid #d1d1d1' }} onClick={() => closeRepeat(item.name, item.id)}>{item.name}</div>
            ))
          }
        </div>
      </div>
    );
  }
}